module.exports = "./img/3acc879c8b7900654d353bbe19d0873e.png";